import { generateCategorySlugPath } from '@/data/utils/utils';
import { Category } from '@/types';

const routes = {
  home: '/',
  authors: '/authors',
  becomeSeller: '/become-seller',
  search: '/search',
  socialLoginToken: '/social-login-token',
  explore: '/explore',
  popularProducts: '/popular-products',
  about: '/about-us',
  contact: '/contact-us',
  cheatsheet: '/midjourney-parameters-cheat-sheet',
  purchases: '/purchases',
  wishlists: '/wishlists',
  reports: '/reports',
  questions: '/questions',
  profile: '/profile',
  checkout: '/checkout',
  help: '/help',
  licensing: '/licensing',
  refund: '/refund',
  terms: '/terms',
  privacy: '/privacy',
  password: '/password',
  feed: '/feed',
  wallet: '/wallet',
  followedShop: '/followed-authors',
  sellerDashboard: '/seller',
  blog: '/blog',
  myPersonalAI: '/my-consistent-ai',
  myAIGallery: '/gallery',
  marketplace: '/products',
  orderUrl: (tracking_number: string) =>
    `/orders/${encodeURIComponent(tracking_number)}`,
  productUrl: (slug: string) => `/products/${slug}`,
  editProductUrl: (productSlug: string, shopSlug: string) =>
    `/seller/${shopSlug}/products/${productSlug}/edit`,
  articleUrl: (slug: string) => `/blog/${slug}`,
  tagUrl: (slug: string) => `/products?tags=${slug}`,
  categoryUrl: (category: Category) =>
    `/products?categories=${generateCategorySlugPath(category)}`,
  shopUrl: (slug: string) => `/authors/${slug}`,
  product: (slug: string) => {
    return `/products/${encodeURIComponent(slug)}`;
  },
  cards: '/cards',
  gallery: '/gallery',
  createGenerator: '/my-consistent-ai/train',
};
export default routes;
